import React, { useEffect, useState } from 'react';
import superAdminService from '../services/superAdminService';
import Card, { CardBody } from '../components/ui/Card';
import Icon from '../components/ui/Icon';
import GlobalTruckLoader from '../components/ui/GlobalTruckLoader';
import EmptyState from '../components/ui/EmptyState';
import SuperAdminLayout from '../components/common/SuperAdminLayout';
import './Dashboard.css';

const SuperAdminDashboard = () => {
  const [kpis, setKpis] = useState({
    totalActiveTenants: 0,
    totalInactiveTenants: 0,
    totalTenants: 0
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadKPIs = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const data = await superAdminService.getTenantKPIs();
        setKpis(data);
      } catch (err) {
        console.error('Error loading tenant KPIs:', err);
        setError(err.message || 'Failed to load tenant statistics');
      } finally {
        setIsLoading(false);
      }
    };

    loadKPIs();
  }, []);

  if (isLoading) {
    return (
      <SuperAdminLayout>
        <div className="loading-container">
          <GlobalTruckLoader />
        </div>
      </SuperAdminLayout>
    );
  }

  if (error) {
    return (
      <SuperAdminLayout>
        <EmptyState
          icon="error"
          title="Error Loading Dashboard"
          message={error}
        />
      </SuperAdminLayout>
    );
  }

  return (
    <SuperAdminLayout>
      {/* KPI Cards */}
      <div className="dashboard-stats">
          <Card className="stat-card">
            <CardBody>
              <div className="stat-content">
                <div className="stat-icon">
                  <Icon name="corporate_fare" size="large" />
                </div>
                <div className="stat-info">
                  <h3>Total Active Tenants</h3>
                  <p className="stat-number">
                    {kpis.totalActiveTenants.toLocaleString()}
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>

          <Card className="stat-card">
            <CardBody>
              <div className="stat-content">
                <div className="stat-icon">
                  <Icon name="corporate_fare" size="large" />
                </div>
                <div className="stat-info">
                  <h3>Total Inactive Tenants</h3>
                  <p className="stat-number">
                    {kpis.totalInactiveTenants.toLocaleString()}
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>

          <Card className="stat-card">
            <CardBody>
              <div className="stat-content">
                <div className="stat-icon">
                  <Icon name="corporate_fare" size="large" />
                </div>
                <div className="stat-info">
                  <h3>Total Tenants</h3>
                  <p className="stat-number">
                    {kpis.totalTenants.toLocaleString()}
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
    </SuperAdminLayout>
  );
};

export default SuperAdminDashboard;

